import React from 'react'
import PropTypes from 'prop-types'

// Import Components
import { Row, Col, Card, Statistic } from 'antd'
import { connect } from 'react-redux'

class WardDetails extends React.PureComponent {
  render() {
    const { clicked, holdingInfo } = this.props

    

    const data = clicked && clicked.object && clicked.object.properties ?
      clicked.object.properties
      :
      {}

    return (
      <div style={ containerStyles }>
        <div style={{ width: '100%', padding: '16px', borderRadius: '4px', border: '1px solid #f0f0f0' }}>
          <Row
            gutter={[ 16, 16 ]}
            style={{
              margin: 0,
              width: '100%'
            }}
          >
            {/* <Col xs={ 24 } sm={ 12 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='Holdings Revenue'
                  value={ data.holdings_revenue }
                  suffix={
                    <span>{ 'Cr' }</span>
                  }
                  valueStyle={{
                    color: '#2ddbac',
                    fontSize: '20px'
                  }}
                />
              </Card>
            </Col> */}

            {/* <Col xs={ 24 } sm={ 12 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='TL Revenue'
                  value={ data.tl_revenue }
                  suffix={
                    <span>{ 'Cr' }</span>
                  }
                  valueStyle={{
                    color: '#2ddbac',
                    fontSize: '20px'
                  }}
                />
              </Card>
            </Col> */}

            <Col xs={ 24 } sm={ 24 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='Total Holdings'
                  value={ holdingInfo?.total_holdings }
                  valueStyle={{
                    // color: '#2ddbac',
                    color: '#c70039',
                    fontSize: '20px'
                  }}
                />
              </Card>
            </Col>

            {/* <Col xs={ 24 } sm={ 12 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='Total TL'
                  value={ data.total_tl }
                  valueStyle={{
                    color: '#2ddbac',
                    fontSize: '20px'
                  }}
                />
              </Card>
            </Col> */}

            <Col xs={ 24 } sm={ 12 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='Unpaid Holdings'
                  value={ holdingInfo?.unpaid_holdings }
                  valueStyle={{
                    color: 'red',
                    fontWeight: 'bold',
                    fontSize: '22px'
                  }}
                />
              </Card>
            </Col>

            <Col xs={ 24 } sm={ 12 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='Paid Holdings'
                  value={ holdingInfo?.paid_holdings }
                  valueStyle={{
                    color: 'green',
                    fontSize: '20px'
                  }}
                />
              </Card>
            </Col>

            {/* <Col xs={ 24 } sm={ 12 }>
              <Card bodyStyle={{ padding: '8px' }} style={ cardHoveredStyles }>
                <Statistic
                  title='Unpaid TL'
                  value={ data.unpaid_tl }
                  valueStyle={{
                    color: '#c70039',
                    fontSize: '20px'
                  }}
                />
              </Card>
            </Col> */}
          </Row>
        </div>
      </div>
    )
  }
}

// JSS Styles
const containerStyles = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  overflow: 'auto'
}

const cardHoveredStyles = {
  borderColor: 'transparent',
  boxShadow: '0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)'
}

// Prop Types
WardDetails.propTypes = {
  clicked: PropTypes.object
}

WardDetails.defaultProps = {
  clicked: null
}

const mapStateToProps = state => ({
  holdingInfo: state?.ward?.holdingInfo ?? false,
})


export default connect(mapStateToProps, null)(WardDetails)




